<template>
  <div>
    <CardedForm
      ref="hollidays_form_ref"
      id="hollidays_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <v-row no-gutters>
        <v-col no-gutters class="pr-2">
          <TextField
            v-model="form.name"
            :validation_rules="form_validations.name"
            label="Name Of Holiday"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pr-0">
          <ImageField
            label="Thumbnail Picture"
            icon="mdi-camera"
            :disabled="is_loading"
            folder="holidays"
            @on-hide-loader="hide_loader"
            @on-show-loader="show_loader"
            @on-success="on_finished_file_upload"
            @on-error="on_file_upload_errors"
            ref="holidays_file_uploader"
            :required="false"
            empty_file_error="No thumbnail image choosen for the holiday"
            :default_value="default_thumbnail"
          >
          </ImageField>
        </v-col>
      </v-row>

      <TextField
        v-model="form.description"
        :validation_rules="form_validations.description"
        label="Description"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <v-row no-gutters>
        <v-col no-gutters class="pr-2">
          <DateField
            label="Starts On"
            v-model="form.starts_on"
            :validation_rules="form_validations.starts_on"
            :disabled="is_loading"
          >
          </DateField>
        </v-col>
        <v-col no-gutters class="pr-0">
          <DateField
            label="Ends On"
            v-model="form.ends_on"
            :validation_rules="form_validations.ends_on"
            :disabled="is_loading"
          >
          </DateField>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col no-gutters class="pr-2 text-left pb-4">
          This holliday starts on <b>{{ start_word }}</b> and ends on
          <b>{{ end_word }}</b>
        </v-col>
      </v-row>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import DateField from "../../../components/DateField";
import ImageField from "../../../components/ImageField";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminHollidaysAdd",
  components: {
    CardedForm,
    TextField,
    DateField,
    ImageField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      default_thumbnail: Utils.default_holidays_thumbnail,
      form: {
        name: "",
        description: "",
        starts_on: new Date().toISOString().substr(0, 10),
        ends_on: new Date().toISOString().substr(0, 10),
        thumb_nail: Utils.default_holidays_thumbnail,
      },
      form_validations: {
        name: [
          Utils.validate.is_required("Holiday name is required"),
          Utils.validate.min_max_length(
            3,
            50,
            "Holiday name should be between 3 and 50 characters "
          ),
        ],
        description: [
            Utils.validate.max_length(
          100,
          "Description should be less than 100 characters"
        ),
        ],
        starts_on: [
          Utils.validate.is_required("Start date is required"),
          Utils.validate.is_date("Start date is not a valid date"),
        ],
        ends_on: [
          Utils.validate.is_required("End date is required"),
          Utils.validate.is_date("End date is not a valid date"),
        ]
      },
      editing_holiday_id: 0,
    };
  },
  methods: {
    on_auto_fill() {
      this.init_form();
      var rnd = Math.ceil(Math.random() * 999);
      this.form.name = "holiday_name_" + rnd;
      this.form.description = "This is a good day " + rnd + " holiday";
      this.form.starts_on = "2020-11-10";
      this.form.ends_on = "2020-11-12";
      this.form.thumb_nail = Utils.default_holidays_thumbnail;
    },
    init_form() {
      this.form.name = "";
      this.form.description = "",
      this.form.starts_on =  new Date().toISOString().substr(0, 10);
      this.form.ends_on = new Date().toISOString().substr(0, 10);
      this.form.thumb_nail = Utils.default_holidays_thumbnail;
    },
    init_editing_form(holiday){
      this.errors = [];
      this.message = "";

      this.editing_holiday_id = holiday.id;
      this.form.name = holiday.name;
      this.form.description = holiday.description;
      this.form.starts_on =  holiday.starts_on;
      this.form.ends_on = holiday.ends_on;
      this.form.thumb_nail = holiday.thumb_nail;
      this.default_thumbnail = holiday.thumb_nail;
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    submit() {
      //validate end date is greater than start date or equal 
      var start_time = new Date(this.form.starts_on).getTime();
      var end_time = new Date(this.form.ends_on).getTime();
      if(start_time > end_time){
        this.errors = ["Start Date has to be less than or equal to end date"];
        this.$refs.hollidays_form_ref.show_error_dialog();
        return;
      }
      this.$refs.holidays_file_uploader.upload_file();
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.hollidays_form_ref.show_error_dialog();
    },
    post_holiday() {
      this.errors = [];
      this.message = "";
      this.show_loader();
      var query = {
        ... this.form,
        _time_starts_on_timestamp: this.form.starts_on,
        _time_ends_on_timestamp: this.form.ends_on
      }
      ServerClient.Holidays.post_holiday(query,(res)=>{
        console.log("Success posting hollidays ", res);
        this.init_form();
        this.$refs.hollidays_form_ref.on_clear_form();
        this.hide_loader();
        this.message = "<b>Operation was successfull</b> <br/>  Holiday was added successfully";
        this.$refs.hollidays_form_ref.show_message_dialog();
      },(errors) => {
        this.errors = errors;
        this.$refs.hollidays_form_ref.show_error_dialog();
        this.hide_loader();
      });
    },
    update_holiday() {
      this.errors = [];
      this.message = "";
      this.show_loader();
      var query = {
        ... this.form,
        id: this.editing_holiday_id,
        _time_starts_on_timestamp: this.form.starts_on,
        _time_ends_on_timestamp: this.form.ends_on
      }
      ServerClient.Holidays.update_holiday(query,(res)=>{
        console.log("Success updating hollidays ", res);
        this.hide_loader();
        this.message = "<b>Operation was successfull</b> <br/>  Holiday was edited successfully";
        this.$refs.hollidays_form_ref.show_message_dialog();
      },(errors) => {
        this.errors = errors;
        this.$refs.hollidays_form_ref.show_error_dialog();
        this.hide_loader();
      });
    },
    on_finished_file_upload(file_url) {
      this.form.thumb_nail = file_url;
      if (this.is_editing == true) {
        this.update_holiday();
      } else {
        this.post_holiday();
      }
    },
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-success-edit");
      } else {
        this.init_form();
      }
    },
  },
  computed: {
    start_word() {
      var word = Utils.date_str_to_words(this.form.starts_on);
      return word;
    },
    end_word() {
      var word = Utils.date_str_to_words(this.form.ends_on);
      return word;
    },
  },
};
</script>